module.exports = __webpack_public_path__ + "img/tour-44.77d131ab.png";